<template>
    <div class="importingProfile">
        <div v-loading.fullscreen.lock="loading">
            <el-form :inline="true" label-width="60px" :model="form">
                <el-form-item label="期间：">
                    <el-radio-group v-model="form.year" @change="getImportConfig">
                        <el-radio :label="radioOption">当年</el-radio>
                        <el-radio :label="radioOption-1">去年</el-radio>
                    </el-radio-group>
                </el-form-item>
                <br />
                <el-form-item label="类型：">
                    <el-radio-group v-model="form.type" @change="getImportConfig">
                        <el-radio label="js">决算</el-radio>
                        <el-radio label="ys">预算</el-radio>
                        <el-radio label="zdy">自定义</el-radio>
                    </el-radio-group>
                    <div>
                        <el-autocomplete v-model="typeText"
                                         size="small"
                                         v-if="form.type=='zdy'"
                                         class="inline-input"
                                         :fetch-suggestions="querySearch"
                                         placeholder='例如"yxb"'
                                         value-key="type"
                                         @select="handleSelect"
                                         @change="iptChange"
                                         clearable></el-autocomplete>
                    </div>
                </el-form-item>
            </el-form>

            <div style="width:100%">
                <el-table :data="sheets" highlight-current-row border element-loading-text="加载中" style="width: 100%" height="650px">
                    <el-table-column label="sheet序号" width="200">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.sheet" size="mini" :disabled='scope.row.flag'></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="固定文件名">
                        <template #default="scope">
                            <el-input v-model="scope.row.filename" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="对应到系统中的名字" type="index" width="150">
                        <template #default="scope">
                            <el-input v-model="scope.row.name" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="跳过多少行" width="180">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.skipRow" size="mini"></el-input-number>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="跳过多少列" width="180">
                        <template #default="scope">
                            <el-input-number v-model="scope.row.skipCol" size="mini"></el-input-number>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="跳过哪些列" width="180">
                        <template #default="scope">
                            <el-input v-model="scope.row.skipCols" size="mini" placeholder="a,b,c" @change="test(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="oper" width="250">
                        <template #default="scope">
                            <el-button @click="insert(scope.$index)" size="mini">插入行</el-button>
                            <el-button @click="lastremove(scope.$index)" size="mini">删除行</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button @click="appendRow" :disabled="sheets.length!=0">添加行</el-button>
                <el-button @click="save()" type="primary" size="medium">保存</el-button>
                <el-button v-if="typeText.length != 0 && form.type == 'zdy'" @click="open" type="primary" size="medium">删除</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { postAsync, getAsync } from '@/api/gk.js'
    export default {
        data() {
            return {
                sheets: [],
                loading: false,
                form: {
                    year: this.$store.state.openYear,
                    type: this.$store.state.openType
                },
                typeText: '',
                profiles: [],
                iptArr: [],
                radioOption:this.$store.state.openYear,
            }
        },
        created() {
            this.getImportConfig()
        },
        methods: {
            test(row){
                if(row.skipCols.length == 0){
                    delete row.skipCols
                }else{
                    row.skipCols = row.skipCols.split(',')
                }
            },
            open() {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.remove()
                }).catch(() => { });
            },
            async remove() {
                let list = this.profiles.filter(e => e.type != this.typeText)
                let saveData = {
                    "profiles": list
                }
                let res = await postAsync(saveData)
                if (res.status == 0) {
                    this.iptArr = list.filter(e => e.year == this.form.year && e.type !== 'ys' && e.type !== 'js')
                    this.profiles = list
                    this.typeText = ''
                    this.sheets = []
                    this.$message('已删除')
                }
            },
            iptChange(val) {
                if (val.length == 0) {
                    this.sheets = []
                } else {
                    if (this.iptArr.find(e => e.type == val)) {
                        this.sheets = this.iptArr.find(e => e.type == val).items
                    } else {
                        this.sheets = []
                    }
                }
            },
            handleSelect(val) {
                this.sheets = val.items
            },
            appendRow() {
                this.sheets.push({
                    sheet: 1,
                    name: "1",
                    skipRow: 5,
                    // skipCol: 9
                })
            },
            insert(index) {
                this.sheets.splice(index + 1, 0, {
                    sheet: 1,
                    name: this.sheets.length + 1 + "",
                    skipRow: 5,
                    // skipCol: 9
                })
            },
            async getImportConfig() {
                this.loading = true
                if (this.profiles.length > 0) {
                    this.changeData()
                } else {
                    this.getProfiles()
                }
                this.loading = false
            },
            async getProfiles(){
                let res = await getAsync()
                    if (res.status == 0) {
                        this.profiles = res.profiles
                        this.profiles.forEach(el=>{
                            el.items.forEach(ele=>{
                                ele.flag = ele.filename ? true : false
                            })
                        })
                        let arr = res.profiles.filter(e => e.year == this.form.year && e.type == this.form.type)
                        this.iptArr = res.profiles.filter(e => e.year == this.form.year && e.type !== 'ys' && e.type !== 'js')
                        this.sheets = arr.length > 0 ? arr[0].items : []
                    }
            },
            changeData(func) {
                if (func != "save") {
                    this.iptArr = this.profiles.filter(e => e.year == this.form.year && e.type !== 'ys' && e.type !== 'js')
                    let arr = []
                    if (this.form.type !== 'zdy') {
                        arr = this.profiles.filter(e => e.year == this.form.year && e.type == this.form.type)
                        this.sheets = arr.length > 0 ? arr[0].items : []
                    } else {
                        if (this.iptArr.find(e => e.type == this.typeText)) {
                            this.sheets = this.iptArr.find(e => e.type == this.typeText).items
                        } else {
                            this.sheets = []
                        }
                    }
                } else {
                    if (this.form.type == 'zdy') {
                        if (this.profiles.filter(e => e.year == this.form.year && e.type == this.typeText).length == 0) {
                            if (this.typeText) {
                                this.profiles.push({
                                    year: this.form.year,
                                    type: this.typeText,
                                    items: this.sheets
                                })
                            }
                        } else {
                            this.profiles.filter(e => e.year == this.form.year && e.type == this.typeText).map(e => {
                                return {
                                    year: e.year,
                                    type: e.type,
                                    items: this.sheets
                                }
                            })
                        }
                    } else {
                        if (this.profiles.filter(e => e.year == this.form.year && e.type == this.form.type).length == 0) {
                            this.profiles.push({
                                year: this.form.year,
                                type: this.form.type,
                                items: this.sheets
                            })
                        } else {
                            this.profiles.filter(e => e.year == this.form.year && e.type == this.form.type).map(e => {
                                return {
                                    year: e.year,
                                    type: e.type,
                                    items: this.sheets
                                }
                            })
                        }
                    }
                }
            },
            async save() {
                if (this.typeText.length != 0 || this.form.type == 'ys' || this.form.type == 'js') {
                    this.loading = true;
                    this.changeData("save")
                    let saveData = {
                        "profiles": this.profiles
                    }
                    let res = await postAsync(saveData)
                    if (res.status === 0) {
                        this.iptArr = this.profiles.filter(e => e.year == this.form.year && e.type !== 'ys' && e.type !== 'js')
                        this.$message('已保存')
                    }
                    this.getProfiles()
                    this.loading = false
                } else {
                    this.$message('请输入自定义表名')
                }
            },
            async lastremove(index) {
                if (this.sheets.length == 0)
                    return;
                this.sheets.splice(index, 1)
            },
            async querySearch(queryString, cb) {
                var restaurants = this.iptArr;
                var results = queryString
                    ? restaurants.filter(this.createFilter(queryString))
                    : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (
                        restaurant.type.toLowerCase().indexOf(queryString.toLowerCase()) !==
                        -1
                    );
                };
            },
        }
    }
</script>

<style scoped>
    .importingProfile {
        width: 100%;
        margin: 30px;
    }

    .el-form-item {
        margin: 0px !important
    }
</style>